import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {CriteriaStrip} from 'src/components/criteria-strip';
import {selectSearchRequest} from 'src/components/criteria-strip/services/criteria-strip-slice';
import {SEARCH_RESULT_TABS} from 'src/constants';
import {useEffectWithDeps} from 'src/hooks/useEffectWithDeps';
import {selectSelectedColumns as selectUserSearchColumns, userSearchResultStateActions} from 'src/modules/user-search-result';
import {isDeepEqual} from 'src/utils/isDeepEqual';

import Typography from '@pb/kit-component-typography';

import {
    searchCriteria,
    searchCriteriaHeader,
    searchCriteriaStripContainer,
} from '../../search-criteria.module.styl';
import {SearchButton} from '../search-button/search-button';

import {UserSearch} from './user-search';


type Props = {
    searchId: string,
};

export const UserSearchCriteria = ({searchId}: Props) => {
    const dispatch = useDispatch();
    const selectedUserColumns = useSelector(selectUserSearchColumns);
    const searchRequest = useSelector(selectSearchRequest);

    useEffect(() => {
        if (searchRequest) {
            dispatch(userSearchResultStateActions.setSearchCriteria(searchRequest));
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffectWithDeps((prev, current) => {
        if (current.searchRequest && !isDeepEqual({prev, current})) {
            dispatch(userSearchResultStateActions.setSearchCriteria(current.searchRequest));
        }
    }, {searchRequest, selectedUserColumns});

    return (
        <div className={searchCriteria}>
            <header className={searchCriteriaHeader}>
                <Typography variant="heading-level-1">Accounts & Users Search</Typography>
                <SearchButton activeTab={SEARCH_RESULT_TABS.USERS} searchId={searchId}/>
            </header>
            <div className={searchCriteriaStripContainer}>
                <CriteriaStrip activeTab={SEARCH_RESULT_TABS.USERS} showClear={true}/>
            </div>
            <UserSearch/>
        </div>
    );
};
